export default () => {
  $('.js-choose-agency').on('click', function() {
    const id = $(this).data('agencyId');
    const name = $(this).data('agencyName');
    chooseAgency(id, name);
  });

  function chooseAgency(id, name) {
    let isChecked = true;
    window.chosenAgencies.forEach(function(ag) {
        if(ag.id ===id){
          isChecked = false;
        }
    });
    if(isChecked) {
      window.chosenAgencies.push({
        name,
        id,
      });
    } else {
      window.chosenAgencies =
        window.chosenAgencies.filter(function(ag) {
        return ag.id !== id;
      });
    }
    updateChosenBlock();
  }

  function updateChosenBlock() {
    const $agenciesList = $('.ordered-agencies__list');
    $agenciesList.html('');
    window.chosenAgencies.forEach(function(ag) {
      const html = `<div class="ordered-agencies__list__item">
        ${ag.name}
        <a data-agency-id="${ag.id}" class="js-item-remove">
          &times;
        </a>
      </div>`;
      $agenciesList.append(html);
    });
    const agenciesHiddenList = window.chosenAgencies.map(function(ag) {
      return ag.id;
    }).join(',');
    $('#agenciesList').val(agenciesHiddenList);
    $('.js-ordered-amount').text(window.chosenAgencies.length)
    $('.js-item-remove')
      .on('click', handleRemoveFromAgencyList)
    if(window.chosenAgencies.length > 0) {
      $('.ordered-agencies').addClass('agencies-chosen');
    } else {
      $('.ordered-agencies').removeClass('agencies-chosen');
    }
  }
  function handleRemoveFromAgencyList() {
    const id = $(this).data('agencyId');
    window.chosenAgencies =
      window.chosenAgencies.filter(function(ag) {
      return ag.id !== id;
    });
    updateChosenBlock();
    $('.js-choose-agency[data-agency-id='+ id + ']').prop('checked', false);
  }
}



// WEBPACK FOOTER //
// ./scripts/util/chooseAgencies.js